/* eslint-disable */
// This file was manually ported over from an example to be edited manually

import { environment } from "environment";
const awsmobile = {
  aws_project_region: 'us-east-1',
  aws_cognito_region: 'us-east-1',
  aws_cognito_identity_pool_id: environment.IDENTITY_POOL_ID,
  aws_user_pools_web_client_id: environment.USER_POOL_APP_CLIENT_ID, // NOTE: This changes when deployed
  aws_user_pools_id: environment.USER_POOL_ID,
  federationTarget: 'COGNITO_USER_POOLS',
  aws_cognito_signup_attributes: ['EMAIL', 'BIRTHDATE'],
};

export default awsmobile;
